import styled from 'styled-components';
import { Formik } from 'formik';
import { AppInput } from '@/layout/AppComponents';
import Translator from '@/layout/components/helpers/Translator';
import AppLink from '@/routing/helpers/AppLink';

export default function AuthClientAmia({ validationSchema, errorMsg, onHandleLogin }) {
  return (
    <Container>
        <nav>
            <div className="container-fluid">
                <img src="/images/client/amia/AMIA_Blanco.png" />
                <span className="float-right">REPOSITORIO AMIA</span>
            </div>
        </nav>
		<div className="container">
			<div className="row">
				<div className="col-lg-12">
					<h2 className="font-weight-bold">Bienvenido al Repositorio de la Academia Mexicana de Impacto Ambiental, A.C.</h2>
					<h2 className="mb-5">Consulta esta <b>herramienta</b> diseñada para fortalecer la colaboración entre miembros de la AMIA, promover el intercambio de conocimientos y consolidar un espacio actualizado que contribuya al trabajo y la profesionalización en materia de impacto ambiental.</h2>
				</div>
			</div>
			<div className="row mt-30">
				<div className="col-lg-6">
					<h3>Como miembro activo de la AMIA, puedes acceder con tu usuario y contraseña para:</h3>
					<div className="action1">
                        <img src="/images/client/amia/icon1.png" />
						<span>Realizar una aportación</span>
					</div>
					<div className="action2">
                        <img src="/images/client/amia/icon2.png" />
						<span>Consultar información</span>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="form-wrapper">
                        <img src="/images/client/amia/login.png" />
						<Formik
                            initialValues={{
                                username: '',
                                password: '',
                            }}
                            validateOnChange={false}
                            validateOnBlur={false}
                            validationSchema={validationSchema}
                            onSubmit={onHandleLogin}
                            >
                            {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
                                <form onSubmit={handleSubmit}>
                                    <AppInput
                                        title="Usuario"
                                        name="username"
                                        value={values.username}
                                        error={errors.username}
                                        onChange={(v) => setFieldValue('username', v)}
                                    />
                                    <AppInput
                                        title="Contraseña"
                                        name="password"
                                        value={values.password}
                                        error={errors.password}
                                        onChange={(v) => setFieldValue('password', v)}
                                        isPassword
                                    />
                                    <button
                                        type="submit"
                                        className="btn-login"
                                        disabled={isSubmitting}
                                    >
                                        Acceder
                                    </button>
                                </form>
                            )}
                        </Formik>
						<div className="mt-2">
                            <AppLink path="user_remember_password" className="forgot-password">
                                <Translator file="user" name="user.password.forgotten" />
                            </AppLink>
						</div>
                        {errorMsg && <div className="mt-2 text-danger text-center"><Translator file="user" name="user.login.error" /></div>}
					</div>
				</div>
			</div>
		</div>
    </Container>
  );
}

const Container = styled.div`
    nav {
        background-color: #1a3664 !important;
        height: 100px;
    }
    nav img {
        width: 150px;
    }
    nav span {
        font-size: 22px;
        font-weight: bold;
        color: #fff;
        padding-top: 36px;
    }
    h1 {
        font-weight: bold;
        text-align: center;
        margin-top: 70px;
        font-size: 30px;
    }
    h2 {
        text-weight: bold;
        text-align: center;
        margin-top: 50px;
        font-size: 26px;
    }
    h3 {
        text-align: center;
        font-size: 22px;
        font-weight: bold;
    }
    .action1,
    .action2 {
        text-align: center;
        margin: 30px 0;
    }
    .action1 span {
        color: #3e9bd9;
        font-weight: bold;
        font-size: 22px;
    }
    .action2 span {
        color: #79b647;
        font-weight: bold;
        font-size: 22px;
    }
    .form-wrapper {
        padding: 20px 100px;
        background-color: #f2f8f9;
    }
    .form-wrapper img {
        width: 350px;
        margin-bottom: 20px;
    }
    form {
        padding: 10px;
        background-color: #fff;
    }
    input {
        background-color: #f9f9f9 !important;
        margin-bottom: 10px;
        border: none !important;
    }
    .btn-login {
        border-radius: 3px;
        margin-top: 20px;
        background-color: #003d47;
        border: 1px solid #547895;
        width: 100%;
        padding: 6px;
        color: #fff;
        font-size: 15px;
    }
    .forgot-password {
        color: #003d47;
    }
`;
